import { useEffect } from 'react';
import { getSelectionRect } from 'libs/common/utils';
/**
 * Use the current selection, the editor bounding rect and the toolbar bounding rect to correctly
 * place the toolbar above the selection.
 * Return a boolean whether the toolbar is open or not.
 * @param editorRef Ref of the draft-js `Editor`
 * @param toolbarRef Ref of the toolbar
 * @param selectionState `SelectionState` of the editor
 * @param keepOpen keeps the toolbar open if `true`, useful when using an input inside it
 */

var useInlineToolbar = function useInlineToolbar(editorRef, toolbarRef, selectionState, keepOpen) {
  useEffect(function () {
    var nativeSelection = window.getSelection();
    /**
     * Toolbar is closed when:
     * - refs are not initialized
     * - the editor selection is empty
     * - the browser native selection is empty
     */

    if (!editorRef.current || !toolbarRef.current || selectionState.isCollapsed() || nativeSelection === null || nativeSelection.rangeCount === 0 || nativeSelection.isCollapsed) {
      return;
    }

    var selectionBoundary = getSelectionRect(nativeSelection);
    var toolbarBoundary = toolbarRef.current.getBoundingClientRect();
    var parentBoundary = editorRef.current.editor.getBoundingClientRect();
    /*
     * Main logic for setting the toolbar position.
     */

    toolbarRef.current.style.bottom = "".concat(parentBoundary.bottom - selectionBoundary.top, "px"); // The left side of the tooltip should be:
    // center of selection relative to parent - half width of toolbar

    var selectionCenter = selectionBoundary.left + selectionBoundary.width / 2 - parentBoundary.left;
    var left = selectionCenter - toolbarBoundary.width / 2;
    var screenLeft = parentBoundary.left + left;

    if (screenLeft < 0) {
      // If the toolbar would be off-screen
      // move it as far left as it can without going off-screen
      left = -parentBoundary.left;
    }

    toolbarRef.current.style.left = "".concat(left, "px");
  }, [selectionState, editorRef, toolbarRef]);

  if (keepOpen) {
    return true;
  }

  var isToolbarOpen = !selectionState.isCollapsed() && selectionState.getHasFocus();
  return isToolbarOpen;
};

export default useInlineToolbar;